import Plugin from "@ckeditor/ckeditor5-core/src/plugin"
import {
  toWidget,
  toWidgetEditable,
} from "@ckeditor/ckeditor5-widget/src/utils"
import { enablePlaceholder } from "@ckeditor/ckeditor5-engine/src/view/placeholder"
import Widget from "@ckeditor/ckeditor5-widget/src/widget"
import InsertTableOfContentsBox from "./insertTableOfContentsBox"

export default class TableOfContentsBoxEditing extends Plugin {
  static get requires() {
    return [Widget]
  }

  init() {
    this.defineSchema()
    this.defineConvrters()
    this.editor.commands.add(
      "insertTableOfContentsBox",
      new InsertTableOfContentsBox(this.editor)
    )
  }

  defineSchema() {
    const schema = this.editor.model.schema

    schema.register("tableOfContentsBox", {
      isObject: true,
      allowWhere: "$block",
    })
    schema.register("tableOfContentsBoxTitle", {
      isLimit: true,
      allowIn: "tableOfContentsBox",
      allowContentOf: "$block",
      allowAttributes: ["id"],
    })
  }

  defineConvrters() {
    const conversion = this.editor.conversion

    // <tableOfContentsBox> converters
    conversion.for("upcast").elementToElement({
      model: "tableOfContentsBox",
      view: {
        name: "div",
        classes: "table-of-contents-box",
      },
    })
    conversion.for("dataDowncast").elementToElement({
      model: "tableOfContentsBox",
      view: {
        name: "div",
        classes: "table-of-contents-box",
      },
    })
    conversion.for("editingDowncast").elementToElement({
      model: "tableOfContentsBox",
      view: (modelElement, viewWriter) => {
        const div = viewWriter.createContainerElement("div", {
          class: "table-of-contents-box",
        })
        return toWidget(div, viewWriter, { label: "table of contents widget" })
      },
    })

    // <tableOfContentsBoxTitle> converters
    conversion.for("upcast").elementToElement({
      model: "tableOfContentsBoxTitle",
      view: {
        name: "h2",
        classes: "table-of-contents-box-title",
      },
    })
    conversion.for("dataDowncast").elementToElement({
      model: "tableOfContentsBoxTitle",
      view: (modelElement, viewWriter) => {
        const h2 = viewWriter.createContainerElement("h2", {
          id: modelElement.getAttribute("id"),
          class: "table-of-contents-box-title",
        })
        return toWidget(h2, viewWriter, {
          label: "table of contents title widget",
        })
      },
    })
    conversion.for("editingDowncast").elementToElement({
      model: "tableOfContentsBoxTitle",
      view: (modelElement, viewWriter) => {
        // Note: You use a more specialized createEditableElement() method here.
        const h2 = viewWriter.createEditableElement("h2", {
          id: modelElement.getAttribute("id"),
          class: "table-of-contents-box-title",
        })
        enablePlaceholder({
          view: this.editor.editing.view,
          element: h2,
          text: "目次を入力して下さい",
        })
        return toWidgetEditable(h2, viewWriter)
      },
    })
  }
}
